import * as React from "react"
import * as styles from "./styles.css"
import { getContextuallyFormattedDate } from "../details/helpers"
import { MerlinStatus } from "@gatsbyjs/graphql/types"

type TimestampsProps = {
  status: string
  createdAt: string
  endedAt: string
}

export function Timestamps({ status, createdAt, endedAt }: TimestampsProps) {
  return (
    <div className={styles.timestamps}>
      <div className={styles.title}>
        Received
        <div className={styles.content}>
          {getContextuallyFormattedDate(createdAt)}
        </div>
      </div>

      {MerlinStatus.Success === status && (
        <div className={styles.title}>
          Finished at
          <div className={styles.content}>
            {getContextuallyFormattedDate(endedAt)}
          </div>
        </div>
      )}

      {MerlinStatus.Failed === status && (
        <div className={styles.title}>
          Failed
          <div className={styles.content}>
            {getContextuallyFormattedDate(endedAt)}
          </div>
        </div>
      )}
    </div>
  )
}
